import { AppState } from 'src/app/store'

export const getMessagesSelector = (state: AppState) => state.messages.messages
export const filterMessageTextSelector = (state: AppState) => state.messages.messages.filterText
export const sendMessageSelector = (state: AppState) => state.messages.sendMessage
export const readUserMessageSelector = (state: AppState) => state.messages.readMessage
export const getMessageCountSelector = (state: AppState) => state.messages.messages.count